// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YGbUv","newExpiryDate":"styles_newExpiryDate__12K0q","footer":"styles_footer__KFM1X"};